import React, { useEffect, useState } from "react";
import { useAdminAuth } from "../context/AdminAuthContext";
import ApprovalModal from "../componants/ApprovalModal";
import { Loader2, UserCheck } from "lucide-react";

const Approvals = () => {
  const { token } = useAdminAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const fetchPending = async () => {
    try {
      const res = await fetch("http://localhost:2027/api/admin/team/pending", {
        headers: { Authorization: `Bearer ${token}` }
      });
      if(res.ok) setUsers(await res.json());
    } catch(err) { console.error(err); } 
    finally { setLoading(false); }
  };

  useEffect(() => { fetchPending(); }, []);

  return (
    <div className="p-6">
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-[#0F172A]">Pending Approvals</h2>
        <p className="text-slate-500 text-sm mt-1">Review and assign roles to new team requests</p>
      </div>
      
      {loading ? (
        <div className="flex justify-center p-20"><Loader2 className="animate-spin text-[#E67E22]" size={40} /></div>
      ) : (
        <div className="bg-white rounded-[24px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] border border-slate-100 overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead className="bg-slate-50/50 border-b border-slate-100 text-[11px] uppercase tracking-[0.1em] text-slate-400 font-bold">
              <tr>
                <th className="p-5 pl-8">Requested Name</th>
                <th className="p-5">Corporate Email</th>
                <th className="p-5 text-right pr-8">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {users.length === 0 ? (
                <tr>
                  <td colSpan={3} className="p-20 text-center">
                    <div className="flex flex-col items-center opacity-40">
                      <UserCheck size={48} className="mb-2 text-slate-300" />
                      <p className="text-slate-500 font-medium">No pending requests at the moment.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                users.map((user: any) => (
                  <tr key={user.id} className="hover:bg-slate-50/50 transition-colors group">
                    <td className="p-5 pl-8 font-bold text-slate-700">{user.name}</td>
                    <td className="p-5 text-slate-500 text-sm">{user.email}</td>
                    <td className="p-5 text-right pr-8">
                      <button 
                        onClick={() => setSelectedUser(user)}
                        className="bg-[#E67E22] hover:bg-[#D35400] text-white px-6 py-2.5 rounded-xl text-xs font-bold uppercase tracking-wider shadow-md shadow-orange-200 transition-all active:scale-95"
                      >
                        Review & Approve
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {selectedUser && (
        <ApprovalModal 
            user={selectedUser} 
            onClose={() => setSelectedUser(null)} 
            onSuccess={fetchPending} 
        />
      )}
    </div>
  );
};

export default Approvals;